export const grabScrollMixin = {
    data() {
        return {
            isGrabbing: false,
            startX: 0,
            scrollLeft: 0,
            excludedClasses: ['flex-cell', 'arrow-icon'] // Default excluded classes
        }
    },
    methods: {
        startGrabbing(e, element) {
            // Check if the target element has any of the excluded classes or is a child of such elements
            if (this.isExcludedElement(e.target)) {
                e.stopPropagation(); // Stop event propagation
                e.preventDefault(); // Prevent default behavior
                return;
            }
            
            this.isGrabbing = true;
            this.startX = e.pageX - element.offsetLeft;
            this.scrollLeft = element.scrollLeft;
            element.style.cursor = 'grabbing';
        },
        stopGrabbing(element) {
            this.isGrabbing = false;
            element.style.cursor = 'grab';
        },
        moveGrabbing(e, element, onScroll) {
            if (!this.isGrabbing) return;
            e.preventDefault();
            const x = e.pageX - element.offsetLeft;
            const walk = (x - this.startX) * 2;
            element.scrollLeft = this.scrollLeft - walk;
            if (onScroll) onScroll(element);
        },
        isExcludedElement(element) {
            // Check if the element or any of its parents has any of the excluded classes
            let currentElement = element;
            while (currentElement && currentElement !== document.body) {
                if (currentElement.classList) {
                    // Check if element has any of the excluded classes
                    for (const className of this.excludedClasses) {
                        if (currentElement.classList.contains(className) || 
                            currentElement.closest(`.${className}`)) {
                            return true;
                        }
                    }
                }
                currentElement = currentElement.parentElement;
            }
            return false;
        },
        // Set excluded classes - can be called from component to customize
        setExcludedClasses(classes) {
            if (Array.isArray(classes)) {
                this.excludedClasses = classes;
            }
        },
        // Add a class to excluded classes
        addExcludedClass(className) {
            if (!this.excludedClasses.includes(className)) {
                this.excludedClasses.push(className);
            }
        },
        // Remove a class from excluded classes
        removeExcludedClass(className) {
            const index = this.excludedClasses.indexOf(className);
            if (index !== -1) {
                this.excludedClasses.splice(index, 1);
            }
        },
        initGrabScroll(element, onScroll, customExcludedClasses) {
            if (!element) return;
            
            // Set custom excluded classes if provided
            if (customExcludedClasses && Array.isArray(customExcludedClasses)) {
                this.setExcludedClasses(customExcludedClasses);
            }
            
            element.style.cursor = 'grab';
            
            // Add specific handlers for excluded elements
            const applyElementHandlers = () => {
                // Create selectors for all excluded classes and their children
                const selectors = [];
                const pointerSelectors = [];
                
                this.excludedClasses.forEach(className => {
                    // Default cursor elements
                    selectors.push(`.${className}`, `.${className} *`);
                    
                    // Special case for arrow-icon which needs pointer cursor
                    if (className === 'arrow-icon') {
                        pointerSelectors.push(`.${className}`, `.${className} *`);
                    }
                });
                
                // Apply default cursor to excluded elements
                if (selectors.length > 0) {
                    const defaultCursorElements = element.querySelectorAll(selectors.join(', '));
                    defaultCursorElements.forEach(el => {
                        el.style.cursor = 'default';
                    });
                }
                
                // Apply pointer cursor to elements that need it
                if (pointerSelectors.length > 0) {
                    const pointerCursorElements = element.querySelectorAll(pointerSelectors.join(', '));
                    pointerCursorElements.forEach(el => {
                        el.style.cursor = 'pointer';
                        
                        // Add a click event listener that stops propagation
                        el.addEventListener('click', (e) => {
                            e.stopPropagation();
                        });
                    });
                }
            };
            
            // Create a MutationObserver to watch for dynamically added elements
            const observer = new MutationObserver(() => {
                applyElementHandlers();
            });
            
            // Start observing the element for DOM changes
            observer.observe(element, { 
                childList: true, 
                subtree: true 
            });
            
            const mouseDownHandler = (e) => this.startGrabbing(e, element);
            const mouseUpHandler = () => this.stopGrabbing(element);
            const mouseMoveHandler = (e) => this.moveGrabbing(e, element, onScroll);
            
            // Apply the handlers
            applyElementHandlers();
            
            element.addEventListener('mousedown', mouseDownHandler);
            window.addEventListener('mouseup', mouseUpHandler);
            window.addEventListener('mousemove', mouseMoveHandler);
            
            return () => {
                element.removeEventListener('mousedown', mouseDownHandler);
                window.removeEventListener('mouseup', mouseUpHandler);
                window.removeEventListener('mousemove', mouseMoveHandler);
                observer.disconnect(); // Clean up the observer
            };
        }
    }
} 